var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { ContrastButton } from './ContrastButton';
import { CriticalButton } from './CriticalButton';
import { PrimaryButton } from './PrimaryButton';
import { SecondaryButton } from './SecondaryButton';
import { TextButton } from './TextButton';
const ButtonComponent = (_a, ref) => {
    var _b;
    var { variant } = _a, baseProps = __rest(_a, ["variant"]);
    // To be removed when dropping the `fullWidth` support
    const props = Object.assign(Object.assign({}, baseProps), { width: (_b = baseProps.width) !== null && _b !== void 0 ? _b : (baseProps.fullWidth ? '100%' : undefined), fullWidth: undefined });
    switch (variant) {
        case 'primary':
            return _jsx(PrimaryButton, Object.assign({}, props, { ref: ref }));
        case 'secondary':
            return _jsx(SecondaryButton, Object.assign({}, props, { ref: ref }));
        case 'text':
            return _jsx(TextButton, Object.assign({}, props, { ref: ref }));
        case 'critical':
            return _jsx(CriticalButton, Object.assign({}, props, { ref: ref }));
        case 'contrast':
            return _jsx(ContrastButton, Object.assign({}, props, { ref: ref }));
        default:
            return _jsx(PrimaryButton, Object.assign({}, props, { ref: ref }));
    }
};
export const Button = forwardRef(ButtonComponent);
